import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Table from './table'
import FormModal from './form-modal'
import FlashAlert from '../../components/flash-alert'
import { ajaxDelete } from '../../ajax'

function Banners({banners, regions, onCreate, onUpdate, onDelete}) {
  const [showForm, setShowForm] = useState()
  const [alert, setAlert] = useState()
  const [loading, setLoading] = useState(false)

  const onCreated = (data) => {
    onCreate(data)
    setShowForm()
    setAlert({ text: 'Banner has been added', type: 'success' })
  }

  const onUpdated = (data) => {
    onUpdate(data)
    setShowForm()
    setAlert({ text: 'Banner has been updated', type: 'success' })
  }

  const onDeleteClicked = async (banner) => {
    if (window.confirm('Are you sure you want to delete this banner? The action cannot be undone')) {
      deleteBanner(banner)
    }
  }

  const deleteBanner = async (banner) => {
    setLoading(true)
    const url = `/admins/banners/${banner.id}.json`
    const response = await ajaxDelete(url)
    await response.json()
    setLoading(false)
    setAlert({ text: 'Banner has been deleted', type: 'success' })
    onDelete(banner)
  }

  return <div className={'banners-content' + (loading ? ' isLoading' : '')}>
    { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} />}
    { loading && <div className='animated-spinner'></div> }
    <div className='banners-header'>
      <div className='banners-title'>Partnerships Banners</div>
      <button className='btn btn-success' onClick={() => setShowForm({})}>Create</button>
    </div>
    <Table
      banners={banners}
      onEdit={banner => setShowForm(banner)}
      onDelete={banner => onDeleteClicked(banner)}
    />
    { showForm && 
      <FormModal
        data={showForm}
        regions={regions}
        onClose={() => setShowForm()}
        onCreate={onCreated}
        onUpdate={onUpdated}
      />
    }
  </div>
}

Banners.propTypes = {
  banners: PropTypes.array.isRequired,
  regions: PropTypes.array.isRequired,
  onCreate: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}

export default Banners
